import './Skeleton.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var skeletonPlaceholderCSS = _7a468({defaultClassName:'_1a1ozfd0-3-15-1',variantClassNames:{variant:{'default':'_1a1ozfd1-3-15-1',rounded:'_1a1ozfd2-3-15-1'}},defaultVariants:{},compoundVariants:[]});
export var skeletonSvgBackgroundFillCSS = '_1a1ozfd5-3-15-1';
export var skeletonSvgCSS = '_1a1ozfd3-3-15-1';
export var skeletonSvgGradientCSS = '_1a1ozfd4-3-15-1';
export var skeletonSvgGradientRectCSS = '_1a1ozfd6-3-15-1';